// extracted by mini-css-extract-plugin
export default {"icon":"feed-options-switch-module-icon-0sKvX","active":"feed-options-switch-module-active-UtqHO","switchIcon":"feed-options-switch-module-switchIcon-XJyv+"};